var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComeBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2287 1.70212C16.8535 2.24605 16.9191 3.19352 16.3752 3.81838L15.1763 5.19561C15.7616 5.12594 16.3694 5.08755 17.0003 5.08755C24.6145 5.08755 30.7828 11.2558 30.7828 18.87C30.7828 26.4843 24.6145 32.6525 17.0003 32.6525C9.38601 32.6525 3.21777 26.4843 3.21777 18.87C3.21777 16.0411 4.0767 13.4017 5.53803 11.2097C5.99756 10.5204 6.92886 10.3341 7.61816 10.7936C8.30745 11.2532 8.49371 12.1845 8.03418 12.8738C6.88884 14.5918 6.21777 16.6556 6.21777 18.87C6.21777 24.8275 11.0429 29.6525 17.0003 29.6525C22.9577 29.6525 27.7828 24.8275 27.7828 18.87C27.7828 12.9126 22.9577 8.08755 17.0003 8.08755C16.2023 8.08755 15.4481 8.1637 14.7334 8.29567L16.8082 9.81019C17.4773 10.2986 17.6238 11.237 17.1353 11.9061C16.6469 12.5753 15.7085 12.7217 15.0394 12.2333L10.2854 8.76297C10.2445 8.73409 10.2047 8.70289 10.1661 8.66937C10.0741 8.58971 9.99399 8.50082 9.92605 8.40511C9.63159 7.99087 9.56963 7.45476 9.75336 6.98763C9.80139 6.86553 9.8662 6.74814 9.94804 6.63887C9.97533 6.60233 10.004 6.56738 10.0339 6.53405L14.1124 1.84866C14.6563 1.22381 15.6038 1.1582 16.2287 1.70212Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComeBack);
export default __webpack_public_path__ + "static/media/come-back.a82ac8c50b5f5dc71175a13e512e922a.svg";
export { ForwardRef as ReactComponent };